/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserFromJSON, UserToJSON, } from './';
export function QueueReportCommandFromJSON(json) {
    return QueueReportCommandFromJSONTyped(json, false);
}
export function QueueReportCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'outputType': !exists(json, 'outputType') ? undefined : json['outputType'],
        'user': !exists(json, 'user') ? undefined : UserFromJSON(json['user']),
        'reportId': !exists(json, 'reportId') ? undefined : json['reportId'],
        'sortField': !exists(json, 'sortField') ? undefined : json['sortField'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'reportName': !exists(json, 'reportName') ? undefined : json['reportName'],
        'foundSetIds': !exists(json, 'foundSetIds') ? undefined : json['foundSetIds'],
        'findFilters': !exists(json, 'findFilters') ? undefined : json['findFilters'],
    };
}
export function QueueReportCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'outputType': value.outputType,
        'user': UserToJSON(value.user),
        'reportId': value.reportId,
        'sortField': value.sortField,
        'propertyId': value.propertyId,
        'reportName': value.reportName,
        'foundSetIds': value.foundSetIds,
        'findFilters': value.findFilters,
    };
}
